import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';

export default class NoteCategoryDto extends BaseAgencyScopeEntityDto {
    name = '';
	status: number;
    isEnabledOnWorkerGeneral: boolean;
    isEnabledOnWorkerCall: boolean;
    isEnabledOnWorkerMeeting: boolean;
    isEnabledOnCompanyGeneral: boolean;
    isEnabledOnCompanyCall: boolean;
    isEnabledOnCompanyMeeting: boolean;
    isEnabledOnLocationGeneral: boolean;
    isEnabledOnLocationCall: boolean;
    isEnabledOnLocationMeeting: boolean;
    isEnabledOnContactGeneral: boolean;
    isEnabledOnContactCall: boolean;
    isEnabledOnContactMeeting: boolean;
    isEnabledOnCampaignGeneral: boolean;
    isEnabledOnCampaignCall: boolean;
    isEnabledOnCampaignMeeting: boolean;
    isEnabledOnJobGeneral: boolean;
    isEnabledOnJobCall: boolean;
    isEnabledOnJobMeeting: boolean;
    isEnabledOnBookingGeneral: boolean;
    isEnabledOnBookingCall: boolean;
    isEnabledOnBookingMeeting: boolean;
}
